import { Component, forwardRef, Injector, StaticProvider } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Gender, createGenderOptions } from "@main/users";
import { ControlBase } from "../control-base";

const GenderValueAccessor = <StaticProvider>{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GenderControlComponent),
    multi: true
};

@Component({
    selector: "m-gender-control",
    template: `
        <p-dropdown
            [disabled]="disabled"
            [options]="genders"
            [(ngModel)]="gender"
            placeholder="Select"
            [showClear]="true"
            (onBlur)="_onBlur()"
            (onChange)="onChange($event.value)">
        </p-dropdown>
    `,
    providers: [GenderValueAccessor]
})
export class GenderControlComponent extends ControlBase<Gender> {
    gender: Gender;
    genders = createGenderOptions();

    writeValue(obj: Gender): void {
        this.gender = obj;
    }
}
